<template>
  <div class="container-xl mt-3">
    <div class="row row-cards">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        <!-- Page title -->
        <div class="page-header d-print-none mb-2">
          <div class="row align-items-center">
            <div class="col">
              <h2 class="page-title">個人資訊</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="row g-2 align-items-center">
                  <div class="col-auto">
                    <span
                      class="avatar"
                      :style="{
                        background: '#fff center/cover',
                        backgroundImage:
                          'url(\'' +
                          require('../assets/images/merchant.png') +
                          '\')',
                      }"
                    ></span>
                  </div>
                  <div class="col">
                    <h3 class="mb-0">
                      <span>{{ profileInfo.email }}</span>
                    </h3>
                  </div>
                  <div class="col-auto lh-1 align-self-start">
                    <span
                      :class="
                        profileInfo.emailVerification
                          ? 'badge bg-green-lt'
                          : 'badge bg-gray-lt'
                      "
                    >
                      {{ verifyStatusStr(profileInfo.emailVerification) }}
                    </span>
                  </div>
                </div>
                <div class="row g-2 align-items-center"></div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-8">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">安全性</h3>
              </div>
              <div class="card-body">
                <div
                  :class="
                    alertStatus === 'success'
                      ? 'alert alert-success'
                      : 'alert alert-danger'
                  "
                  v-show="alertStatus !== ''"
                  role="alert"
                >
                  {{ alertMsg }}
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-md-3 col">信箱驗證</div>
                  <div class="col-md-6 col">
                    <div class="col-auto lh-1 align-self-start">
                      <span
                        :class="
                          profileInfo.emailVerification
                            ? 'badge bg-green-lt'
                            : 'badge bg-gray-lt'
                        "
                      >
                        {{ verifyStatusStr(profileInfo.emailVerification) }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3 col">
                    <button
                      @click.prevent="sendVerifyEmail"
                      :class="
                        profileInfo.emailVerification
                          ? 'btn btn-outline-secondary w-100 disabled'
                          : 'btn btn-outline-info w-100'
                      "
                      id="sendVerifyEmail"
                    >
                      {{
                        emailVerificationButtonText
                      }}
                    </button>
                  </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-md-3 col">手機號碼驗證</div>
                  <div class="col-md-6 col">
                    <div class="col-auto lh-1 align-self-start">
                      <span
                        :class="
                          profileInfo.phoneVerification
                            ? 'badge bg-green-lt'
                            : 'badge bg-gray-lt'
                        "
                      >
                        {{ verifyStatusStr(profileInfo.phoneVerification) }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3 col">
                    <router-link
                      to="addPhoneNumber"
                      :class="
                        profileInfo.phoneVerification
                          ? 'btn btn-outline-secondary w-100 disabled'
                          : 'btn btn-outline-info w-100'
                      "
                    >
                      {{ profileInfo.phoneVerification ? "已驗證" : "驗證" }}
                    </router-link>
                  </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-md-3 col">密碼</div>
                  <div class="col-md-6 col">
                    <div class="col-auto lh-1 align-self-start">
                      <span class="badge bg-green-lt"> 已加密 </span>
                    </div>
                  </div>
                  <div class="col-md-3 col">
                    <router-link
                      to="changePassword"
                      class="btn btn-outline-info w-100"
                    >
                      修改
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      profileInfo: {
        phoneVerification: false,
        emailVerification: false,
        KYCVerificationStatus: false,
        KYCBankingVerificationStatus: false,
        email: "",
        
      },
      emailVerificationButtonText: this.emailVerification ? "已驗證" : "重發驗證信",
      token: "",
      alertMsg: "",
      alertStatus: "",
      countDown: 60,
    };
  },
  methods: {
    async getProfileInfo() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.profileInfo.phoneVerification = res.data.data.phoneVerification;
        this.profileInfo.emailVerification = res.data.data.emailVerification;
        this.profileInfo.KYCVerificationStatus =
          res.data.data.KYCVerificationStatus;
        this.profileInfo.KYCBankingVerificationStatus =
          res.data.data.KYCBankingVerificationStatus;
        this.profileInfo.email = res.data.data.email;
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
      }
    },
    verifyStatusStr(status) {
      return status ? "已驗證" : "未驗證";
    },
    async sendVerifyEmail() {
      try {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/email/send`;
        const res = await this.$http.post(
          api,
          {},
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        if (res.data.status !== "success") {
          throw "error";
        }
        const countDown = setInterval(() => {
          document.getElementById("sendVerifyEmail").setAttribute("disabled","disabled");
          document.getElementById("sendVerifyEmail").innerHTML = --this.countDown + 's';
          
          if (this.countDown == 0) {
            document.getElementById("sendVerifyEmail").innerHTML = this.emailVerificationButtonText;
            document.getElementById("sendVerifyEmail").removeAttribute("disabled");
            clearInterval(countDown)
          }
        }, 1000)
        this.alertStatus = "success";
        this.alertMsg = "已發送";
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
        this.alertStatus = "Error";
        this.alertMsg = "錯誤";
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getProfileInfo();
  },
};
</script>